<template>
    <div class="container text-center my-4">
      <h2>Complete Registration</h2>
      <input v-model="email" type="email" class="form-control my-3" placeholder="Email" :disabled="true" />
      <input v-model="firstName" type="text" class="form-control my-3" placeholder="Nombre" />
      <input v-model="lastName" type="text" class="form-control my-3" placeholder="Apellido" />
      <input v-model="birthDate" type="date" class="form-control my-3" placeholder="Fecha de Nacimiento" />
      <div class="form-check my-2">
        <input v-model="acceptMarketing" type="checkbox" class="form-check-input" id="marketing" />
        <label class="form-check-label" for="marketing">Aceptar comunicación</label>
      </div>
      <div class="form-check my-2">
        <input v-model="acceptTerms" type="checkbox" class="form-check-input" id="terms" />
        <label class="form-check-label" for="terms">Aceptar términos y condiciones</label>
      </div>
      <button class="btn btn-primary" @click="submitForm">Aceptar</button>
      <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        email: this.$route.query.email || '',
        firstName: '',
        lastName: '',
        birthDate: '',
        acceptMarketing: false,
        acceptTerms: false,
        errorMessage: '',
      };
    },
    methods: {
      submitForm() {
        if (!this.firstName || !this.lastName || !this.birthDate) {
          this.errorMessage = 'Completa todos los campos.';
        } else if (!this.acceptTerms) {
          this.errorMessage = 'Debes aceptar los términos y condiciones.';
        } else {
          this.$router.push('/welcome');
        }
      },
    },
  };
  </script>
  